import React, { useEffect } from "react";
import MainBanner from "./DagaHome/MainBanner";
import ShopByCategoryBlock from "./DagaHome/ShopByCategoryBlock";
import CuratedBlock from "./DagaHome/CuratedBlock";
import BridalBlock from "./DagaHome/BridalBlock";
import NewArrivalsBlock from "./DagaHome/NewArrivalsBlock";
import ShopByCollectionBlock from "./DagaHome/ShopByCollectionBlock";
import TopSellingBlock from "./DagaHome/TopSellingBlock";
import WhatPeopleSaysBlock from "./DagaHome/WhatPeopleSaysBlock";
import GetInTouch from "./DagaHome/GetInTouch";
import ComingSoonBlock from "./DagaHome/ComingSoonBlock";
import { useLocation } from "react-router-dom";
import TryonVideoBlock from "./DagaHome/TryonVideoBlock";

function DagaHome({ homeData }) {
  const { hash } = useLocation();
  const comingSoonRef = React.useRef(null);
  useEffect(() => {
    if (hash === "#coming-soon") {
      comingSoonRef?.current.scrollIntoView({ top: 0, behavior: "smooth" });
    }
  }, [hash]);

  return (
    <div>
      <MainBanner homeData={homeData?.home} />
      <ShopByCategoryBlock homeData={homeData?.home} />
      <ShopByCollectionBlock homeData={homeData?.home}/>
      <TryonVideoBlock homeData={homeData?.home} />
      <NewArrivalsBlock homeData={homeData?.home} />
      {/* <BridalBlock homeData={homeData?.home} /> */}
      <CuratedBlock homeData={homeData?.home} />
      <div id="coming-soon" ref={comingSoonRef}>
        <ComingSoonBlock homeData={homeData?.home} />
      </div>
      {/* <TopSellingBlock/> */}
      {/* <WhatPeopleSaysBlock/> */}
    </div>
  );
}

export default DagaHome;
